// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useEffect, useState, useContext} from 'react';
import {useHistory} from 'react-router';
import cn from 'classnames';
import Icon_close from '../../../img/icons/24/close.svg';
import Img_alert_warning from '../../../img/dashboard/payment_alert_warning.svg';
import Img_alert_error from '../../../img/dashboard/payment_alert_error.svg';
import {use_theme} from '../../../../../hola/pub/settings_ctx';
import hola_opt from 'hola_opt';
// @ts-ignore
import cookie from 'cookie';
import date from '/util/date.js';
import {get_payment_renew_url, get_renew_error_orders} from '../utils';
import {Button} from '../../../../../hola/pub/lib/button';
import {use_app_context} from '../../../lib/app_context';
import {Settings_context} from '../../../../../hola/pub/settings_ctx';
import {Modal} from '../../../../../hola/pub/lib/modal';
import storage from '/util/storage.js';

import styles from './alert.module.less';
interface i_dashboard_alerts_props {
    icon_warn: JSX.Element;
    icon_error: JSX.Element;
    btn_color?: 'transparent' | 'black'
}

export const Dashboard_alerts = (props: i_dashboard_alerts_props)=>{
    const [show_alert, set_show_alert] = useState(
      hola_opt.www_hola.dashboard_alert
      && !cookie.get('hide_dashboard_alert'));
    const {dashboard, renew_error_expired_in_day,
        renew_error_orders} = use_app_context();
    const [show_payment_err, set_show_payment_err] = useState(false);
    useEffect(()=>{
        if (renew_error_orders.length>0)
            set_show_payment_err(true);
    }, [dashboard.info?.inited]);
    const error_orders = get_renew_error_orders(dashboard.info.orders);
    if (show_payment_err && error_orders?.length > 0)
    {
        const order = error_orders[0];
        const update_url = get_payment_renew_url(order);
        const renew_update_cc = ()=>{
            storage.set('renew_update_cc_orig', location.pathname);
            return update_url;
        };
        return <Dashboard_alert key='zone_alert'
          icon_warn={props.icon_warn}
          icon_error={props.icon_error}
          btn_color={props.btn_color}
          immediate={renew_error_expired_in_day}
          msg={<>
            <span className={styles.text_bold}>Action required: </span>
            Update your payment method to avoid losing
            access to your proxies permanently</>}
          action_btn_text='Update payment method'
          action_btn_to={renew_update_cc}
          on_close={()=>set_show_payment_err(false)}
        />;
    }
    return show_alert ? <Dashboard_alert key='dashboard_alert'
      icon_warn={props.icon_warn}
      icon_error={props.icon_error}
      btn_color={props.btn_color}
      msg={hola_opt.www_hola.dashboard_alert}
      action_btn_text='Contact'
      action_btn_to='mailto:support@oculusproxies.com'
      on_close={()=>{
        cookie.set('hide_dashboard_alert', 1, {
          path: '/',
          domain: `.${window.location.host}`,
          expires: date.add(date(), {year: 10}),
        });
        set_show_alert(false);
      }}
    /> : null;
};


interface i_dashboard_alert_props {
    msg: string | JSX.Element;
    icon_warn: JSX.Element;
    icon_error: JSX.Element;
    action_btn_text: string
    action_btn_to: string | (()=>string);
    immediate?: boolean
    btn_color?: 'transparent' | 'black'
    on_close: ()=>void;
}
export const Dashboard_alert = (props: i_dashboard_alert_props)=>{
    const {msg, action_btn_text, action_btn_to, immediate, on_close} = props;
    const history = useHistory();
    const {theme} = use_theme();
    const to_or_on_click = typeof action_btn_to == 'string' ?
        {to: action_btn_to} :
        {on_click: ()=>{
            const url = action_btn_to();
            history.push(url);
        }};
    return <div className={cn(styles.dashboard_alert,
      immediate && styles.immediate)}>
      <div className={styles.msg_wrapper}>
        <div className={styles.icon}>
          {immediate ? props.icon_error : props.icon_warn}
        </div>
        <p className={cn(theme.p14, theme.color_n700)}>{msg}</p>
      </div>
      <Button color={props.btn_color ?? 'black'} caption={action_btn_text}
        size="xs" round={false} {...to_or_on_click}
        cls={styles.button_update} />
      <Button color="transparent_grey" caption={<Icon_close/>} round={false}
        size="xs" on_click={on_close} cls={styles.close}/>
    </div>;
};

interface i_expiring_dialog_alert_props {
    on_confirm: ()=>void;
    close: ()=>void;
    close_on_click_outside?: boolean;
    is_open: boolean;
    renew_error_expired_in_day: boolean;
}
export const Expiring_dialog_alert = (props: i_expiring_dialog_alert_props)=>{
    const {theme} = useContext(Settings_context);
    const {renew_error_expired_in_day} = props;
    return <Modal lighter_close_btn={true} is_open={props.is_open}
      width={403} on_close={props.close}
      on_overlay_click={ev=>{
        ev.stopPropagation();
        if (props.close_on_click_outside)
          props.close();
      }}
      paddingless={true}>
      <div className={styles.expiring_modal}>
        <div className={styles.hero_img}>{renew_error_expired_in_day ?
          <Img_alert_error/> : <Img_alert_warning/>}
        </div>
        <p className={cn(theme.p16, theme.med, theme.color_n700, styles.mb)}>
            {renew_error_expired_in_day
              ? 'Update your payment method. Last chance to keep your proxies'
              : 'Update your payment method to keep your proxies'
            }
        </p>
        <p className={cn(theme.p12, theme.color_n500)}>
          There was an issue with your payment, and your proxies
          are at risk of being removed
          {renew_error_expired_in_day ? ' today' : ' soon'}
          <br/>
          <br/>
          {renew_error_expired_in_day && <>
            Simply update your payment details
            to make sure you don't lose access to your proxies permanently
          </>}
          {!renew_error_expired_in_day && <>
            Update your payment method now to
            save your proxies before they're permanently removed
          </>}
        </p>
        <div className={styles.btn_container}>
          <Button caption='Update payment method' color='black' round={false}
            size='sm' cls={theme.med}
            on_click={props.on_confirm}/>
        </div>
        <p className={cn(theme.p12, theme.color_n700)}>
          Need our help with anything?&nbsp;
          <a className={styles.link_underline}
            href='mailto:support@toolip.io'>Contact support</a>
        </p>
      </div>
    </Modal>;
};
